import { motion } from "framer-motion";
import { IMAGES } from "@/lib/images";
import { Container, Overline, SectionHeading, Reveal } from "@/components/primitives";

const PHASES = [
  {
    tag: "Phase I",
    year: "2027",
    place: "Massa Lubrense",
    count: "20",
    note: "The Founding 20 — the first exceptional villas of Massa Lubrense, on the Sorrento Peninsula, setting the standard for everything that follows.",
  },
  {
    tag: "Phase II",
    year: "By Summer 2028",
    place: "The Full Coast",
    count: "80",
    note: "The Collection extends across the Amalfi Coast — a further eighty villas, twenty in each of its most celebrated destinations.",
  },
];

const REGIONS_2028 = [
  { name: "Sorrento", count: "20" },
  { name: "Positano", count: "20" },
  { name: "Praiano", count: "20" },
  { name: "Amalfi", count: "20" },
];

export default function PathTo100() {
  return (
    <section className="relative py-28 md:py-40 bg-navy-800 border-y border-ivory/10 overflow-hidden" data-testid="path-to-100">
      <img src={IMAGES.positanoDusk} alt="" className="absolute inset-0 w-full h-full object-cover opacity-10" />
      <div className="absolute inset-0 bg-navy-800/70" />
      <Container className="relative">
        <div className="max-w-3xl">
          <Reveal>
            <Overline>The Roadmap</Overline>
            <SectionHeading className="mt-8">The path to one hundred.</SectionHeading>
            <p className="mt-8 text-ivory/65 text-lg font-light leading-relaxed">
              VillaFlow Private Collection grows slowly and deliberately. Our ambition is singular:
              to bring together the one hundred finest villas of the Amalfi Coast — and no more.
            </p>
          </Reveal>
        </div>

        {/* Phases */}
        <div className="mt-20 grid lg:grid-cols-2 gap-px bg-ivory/10 border border-ivory/10">
          {PHASES.map((p, i) => (
            <Reveal key={p.tag} delay={i * 0.1}>
              <div className="bg-navy-800 p-10 md:p-14 h-full">
                <div className="flex items-center justify-between">
                  <span className="text-[11px] tracking-[0.3em] uppercase text-gold">{p.tag}</span>
                  <span className="text-[11px] tracking-[0.2em] uppercase text-ivory/45">{p.year}</span>
                </div>
                <div className="mt-8 flex items-end gap-5">
                  <span className="font-serif text-7xl md:text-8xl text-gold leading-none">{p.count}</span>
                  <span className="font-serif text-3xl md:text-4xl text-ivory/90 leading-none pb-2">{p.place}</span>
                </div>
                <p className="mt-8 text-ivory/55 font-light leading-relaxed max-w-md">{p.note}</p>

                {i === 1 && (
                  <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-px bg-ivory/10 border border-ivory/10">
                    {REGIONS_2028.map((r) => (
                      <div key={r.name} className="bg-navy-800 p-5 text-center">
                        <p className="font-serif text-3xl text-ivory">{r.count}</p>
                        <p className="mt-1 text-[9px] tracking-[0.18em] uppercase text-ivory/45">{r.name}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Reveal>
          ))}
        </div>

        {/* The 100 */}
        <Reveal delay={0.1}>
          <div className="mt-16 border border-gold/25 px-8 py-14 md:py-20 text-center">
            <p className="text-[11px] tracking-[0.3em] uppercase text-ivory/45">Entire Amalfi Coast · By Summer 2028</p>
            <div className="mt-6 flex items-center justify-center gap-4">
              <span className="font-serif text-7xl md:text-9xl text-gold leading-none">100</span>
            </div>
            <p className="mt-6 font-serif text-2xl md:text-4xl text-ivory font-light tracking-tight">
              The one hundred finest villas of the Amalfi Coast.
            </p>
            <p className="mt-6 text-ivory/55 font-light max-w-xl mx-auto">
              Once complete, the Collection closes. One hundred villas — a definitive, curated portrait
              of the coast's most exceptional hospitality.
            </p>
          </div>
        </Reveal>
      </Container>
    </section>
  );
}
